import { loadOptions } from '../../versa/formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: '0', label: 'Pendente' },
			{ value: '1', label: 'Verificado' },
			{ value: '3', label: 'Etiquetado' },
			{ value: '5', label: 'Armazenado' },
			{ value: '7', label: 'Armazenado' },
			{ value: '8', label: 'Bloqueado' },
			{ value: '9', label: 'Bloqueado' },
			{ value: '11', label: 'Bloqueado' },
			{ value: '15', label: 'Bloqueado' }
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

